import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-folder-structure',
    templateUrl: './folder-structure.component.html',
    styleUrls: [
        '../../rendered.component.scss',
        './folder-structure.component.scss',
    ],
    standalone: false
})
export class FolderStructureComponent implements OnInit {
  @Input() basefolder;
  @Input() folder;
  @Output() folderClicked = new EventEmitter<any>();
  constructor() {}

  ngOnInit() {}

  clicked(folder) {
    this.folderClicked.emit(folder);
  }
}
